const calculateSplitInfo = interval => {
  if (interval <= 1) {
    return null;
  }

  const splits = [];
  let remaining = interval;

  while (remaining > 0) {
    let chunkSize = 1;
    let foundOptimal = false;

    for (let power = 10; power >= 0; power--) {
      const testChunkSize = Math.pow(10, power);
      const count = Math.floor(remaining / testChunkSize);

      if (count >= 2 && count <= 10) {
        chunkSize = testChunkSize;
        foundOptimal = true;
        break;
      }
    }

    if (!foundOptimal) {
      for (let power = 10; power >= 0; power--) {
        const testChunkSize = Math.pow(10, power);
        if (remaining >= testChunkSize) {
          chunkSize = testChunkSize;
          break;
        }
      }
    }

    const count = Math.floor(remaining / chunkSize);
    if (count > 0) {
      splits.push({ size: chunkSize, count });
      remaining = remaining % chunkSize;
    } else {
      break;
    }
  }

  return splits.length > 0 ? splits : null;
};

export default calculateSplitInfo;
